import Rollbar from 'rollbar';
import store from '@/store';
import router from '@/router';
import { getActiveProduct, getActiveProductName } from '@/helpers';
import { shouldIgnoreRollbarError } from '@/plugins/rollbarIgnore';

export function getRollbarContext() {
  const route = router.currentRoute;
  return {
    route: {
      path: route?.path,
      name: route?.name,
      params: route?.params,
      query: route?.query,
    },
    product: getActiveProduct(),
    productName: getActiveProductName(),
    timestamp: new Date().toISOString(),
    screenSize: `${window.innerWidth}x${window.innerHeight}`,
  };
}

const rollbar = new Rollbar({
  accessToken: import.meta.env.VITE_ROLLBAR_ACCESS_TOKEN,
  enabled: import.meta.env.VITE_APP_ENV !== 'development' && import.meta.env.VITE_APP_ENV !== 'dev',
  captureUncaught: true,
  captureUnhandledRejections: true,
  // _isUncaught is ignored: we filter by error type not by how it was caught
  checkIgnore: (_isUncaught, args) => shouldIgnoreRollbarError(args),
  payload: {
    environment: import.meta.env.VITE_APP_ENV,
    client: {
      javascript: {
        code_version: '1.0.0',
        source_map_enabled: true,
      },
    },
  },
});

export default rollbar;
